/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';
import dateFormat from 'dateformat';
import Currency from 'react-currency-formatter';
import moment from 'moment';
import { toast } from 'react-toastify';
import TagManager from 'react-gtm-module';
import { SlOptions } from 'react-icons/sl';

import ReactTooltip from 'react-tooltip';

import firebase from '~/services/firebase';
import api from '~/services/api';

import {
  Tr,
  Td,
  StatusTitle,
  Status,
  DuplicateContainer,
  DuplicateIcon,
  DuplicateLoading,
  Card,
  CardLine,
  CardTop,
  CodeTitle,
  Code,
  TitleLine,
  OptionsIcon,
  DescriptionLine,
  Hr,
  SelectedItem,
} from './styles';

dateFormat.i18n = {
  dayNames: [
    'Seg',
    'Ter',
    'Qua',
    'Qui',
    'Sex',
    'Sab',
    'Dom',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado',
    'Domingo',
  ],
  monthNames: [
    'Jan',
    'Feb',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  timeNames: ['a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'],
};

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      invoice: '',
      customer: '',
      installment: '',
      loadingDownload: false,
      loadingDownloadXML: false,
      loadingEmail: false,
      status: null,
    };
  }

  componentDidMount() {
    const { invoice, installment, status } = this.props;
    this.organizeData(invoice, installment);
  }

  organizeData = async (invoice, installment) => {
    this.setState({ loading: true });
    const { customer } = invoice;
    return await this.setState({
      token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
      invoice,
      customer,
      installment,
    });
  };

  requestDownloadXML = () => {
    firebase.analytics().logEvent('download_nota', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        download_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        download_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    this.setState({ loadingDownloadXML: true });
    const { customer, invoice, token } = this.state;
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'XML',
      deliveryMethod: 'DOWNLOAD',
      ...(contactIdSf && { contactIdSf }),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.state.invoice.invoiceId}.xml`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.setState({ loadingDownloadXML: false });
      })
      .catch((err) => {
        this.setState({ loadingDownloadXML: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            if (message) {
              toast.error(message);
            } else {
              toast.error(
                'Ocorreu um erro. Por favor, tente novamente mais tarde ou entre em contato com nossa central de atendimento.'
              );
            }
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        } else {
          toast.error(
            'Ocorreu um erro. Por favor, tente novamente mais tarde ou entre em contato com nossa central de atendimento.'
          );
        }
      });
  };

  handleOpenModal = (
    event,
    openModal,
    download,
    sendEmail,
    selectItem,
    sendXML
  ) => {
    if (event) event.stopPropagation();

    if (openModal) {
      this.props.open();
    } else if (download) {
      this.requestDownloadNota();
    } else if (sendEmail) {
      this.requestEmailNota();
    } else if (selectItem) {
      this.props.selectItem();
    } else if (sendXML) {
      this.requestDownloadXML();
    }
  };

  requestDownloadNota = () => {
    this.setState({ loadingDownload: true });
    const { customer, invoice, token } = this.state;
    firebase.analytics().logEvent('download_nota', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        download_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        download_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      responseType: 'blob',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'DANFE',
      deliveryMethod: 'DOWNLOAD',
      ...(contactIdSf && { contactIdSf }),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${this.props.invoice.invoiceId}`,
        body,
        parameters
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.props.invoice.invoiceId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.setState({ loadingDownload: false });
      })
      .catch((err) => {
        this.setState({ loadingDownload: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            if (message) {
              toast.error(message);
            } else {
              toast.error(
                'Ocorreu um erro. Por favor, tente novamente mais tarde ou entre em contato com nossa central de atendimento.'
              );
            }
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        } else {
          toast.error(
            'Ocorreu um erro. Por favor, tente novamente mais tarde ou entre em contato com nossa central de atendimento.'
          );
        }
      });
  };

  requestEmailNota = () => {
    firebase.analytics().logEvent('email_nota', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        email_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        email_nota: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    this.setState({ loadingEmail: true });
    const { customer, invoice, token } = this.state;
    const email = localStorage.getItem('@UltragazEmpresarial:loginEmail');
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'DANFE',
      deliveryMethod: 'EMAIL',
      email,
      ...(contactIdSf && { contactIdSf }),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters
      )
      .then((res) => {
        this.setState({ loadingEmail: false });
        toast.success(`Nota fiscal (PDF) enviada para o e-mail ${email}`);
      })
      .catch((err) => {
        this.setState({ loadingEmail: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            if (message) {
              toast.error(message);
            } else {
              toast.error(
                'Ocorreu um erro. Por favor, tente novamente mais tarde ou entre em contato com nossa central de atendimento.'
              );
            }
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        } else {
          toast.error(
            'Ocorreu um erro. Por favor, tente novamente mais tarde ou entre em contato com nossa central de atendimento.'
          );
        }
      });
  };

  getStatusColor = (status) => {
    return status === 'Pago'
      ? '#75B943'
      : status === 'Vencido'
      ? '#e34e2a'
      : status === 'A vencer'
      ? '#f0b01b'
      : '#000';
  };

  render() {
    const { props } = this;
    const emissionDate = `${props.invoice.emissionDate}T12:00:00`;
    const newEmissionDate = new Date(emissionDate);

    return (
      <div>
        <Tr>
          <Td>
            {props.activeModeDownload && (
              <SelectedItem
                selectAllInvoices={props.selectAllInvoices}
                selectedItem={props.selectedItem}
                disponibleForDownload={props.disponibleForDownload}
                onClick={(e) =>
                  this.handleOpenModal(e, false, false, false, true)}
              />
            )}
            {dateFormat(newEmissionDate, 'mmmm/yyyy')}
          </Td>
          <Td style={{ justifyContent: 'center' }}>
            <Currency
              quantity={props.installment.amountOriginal}
              currency="BRL"
              locale="pt"
            />
          </Td>
          <Td style={{ justifyContent: 'center' }}>
            {props.invoice.invoiceNumber}
          </Td>
          <Td style={{ justifyContent: 'center' }}>
            <DuplicateContainer>
              <div>
                {this.state.loadingDownloadXML ? (
                  <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                ) : (
                  <>
                    <DuplicateIcon
                      className="mdi mdi-xml"
                      aria-label="Download"
                      data-tip
                      data-for="download-xml"
                      onClick={(e) =>
                        this.handleOpenModal(
                          e,
                          false,
                          false,
                          false,
                          false,
                          true
                        )}
                    />
                    <ReactTooltip
                      id="download-xml"
                      place="top"
                      effect="float"
                      type="info"
                    >
                      Download do XML
                    </ReactTooltip>
                  </>
                )}
              </div>

              <div>
                {props.invoice.accessKey && props.disponibleForDownload && (
                  <>
                    {this.state.loadingDownload ? (
                      <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                    ) : (
                      <>
                        <DuplicateIcon
                          className="mdi mdi-cloud-download-outline"
                          aria-label="Download"
                          data-tip
                          data-for="download-nota"
                          onClick={(e) =>
                            this.handleOpenModal(e, false, true, false)}
                        />
                        <ReactTooltip
                          id="download-nota"
                          place="top"
                          effect="float"
                          type="info"
                        >
                          Download do PDF
                        </ReactTooltip>
                      </>
                    )}
                  </>
                )}
              </div>

              <div>
                {this.state.loadingEmail ? (
                  <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                ) : (
                  <>
                    <DuplicateIcon
                      className="mdi mdi-email-outline"
                      aria-label="Enviar nota por e-mail"
                      data-tip
                      data-for="email-nota"
                      onClick={(e) =>
                        this.handleOpenModal(e, false, false, true)}
                    />
                    <ReactTooltip
                      id="email-nota"
                      place="top"
                      effect="float"
                      type="info"
                    >
                      Enviar nota por e-mail
                    </ReactTooltip>
                  </>
                )}
              </div>
              <>
                <DuplicateIcon
                  className="mdi mdi-information-outline"
                  aria-label="Mais informações"
                  data-tip
                  data-for="info-boleto"
                  onClick={(e) => this.handleOpenModal(e, true)}
                />
                <ReactTooltip
                  id="info-boleto"
                  place="top"
                  effect="float"
                  type="info"
                >
                  Mais informações
                </ReactTooltip>
              </>
            </DuplicateContainer>
          </Td>
        </Tr>

        {/* Responsive View */}

        <Card>
          <CardTop>
            {props.activeModeDownload && (
              <SelectedItem
                selectAllInvoices={props.selectAllInvoices}
                selectedItem={props.selectedItem}
                disponibleForDownload={props.disponibleForDownload}
                onClick={(e) =>
                  this.handleOpenModal(e, false, false, false, true)}
              />
            )}
            <OptionsIcon>
              <SlOptions
                key={`card_${props.installment.installmentId}`}
                onClick={(e) => this.handleOpenModal(e, true)}
              />
            </OptionsIcon>
          </CardTop>
          <CardLine>
            <CodeTitle>Referência</CodeTitle>
            <Code>{dateFormat(newEmissionDate, 'mmmm/yyyy')}</Code>
          </CardLine>

          <Hr />

          <CardLine>
            <TitleLine>Emissão</TitleLine>
            <DescriptionLine>
              {moment(newEmissionDate).format('DD/MM/YYYY')}
            </DescriptionLine>
          </CardLine>

          <Hr />

          <CardLine>
            <TitleLine>Valor</TitleLine>
            <DescriptionLine>
              <Currency
                quantity={props.installment.amountOriginal}
                currency="BRL"
                locale="pt"
              />
            </DescriptionLine>
          </CardLine>

          <Hr />

          <CardLine>
            <TitleLine>Nº da Nota</TitleLine>
            <DescriptionLine>{props.invoice.invoiceNumber}</DescriptionLine>
          </CardLine>
        </Card>
      </div>
    );
  }
}
